import React, { useState, useEffect } from "react";
import cn from "classnames";
import styles from "./Shop.module.sass";
import Profile from "./Profile";
import Card from "../../components/Card";
import Dropdown from "../../components/Dropdown";

// screen
import NameAndDescription from "./NameAndDescription";
import ContractAndFiles from "./ContractAndFiles";
import Tutor from "./Tutor";


// data
import { getCurrentCompanyInfo } from "../../services/account.service";

const navigation = ["Informations", "Contrats", "Tuteurs"];

const AccountCompany = () => {
  const [activeIndex, setActiveIndex] = useState(0);
  const [company, setCompany] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchCompanyData = async () => {
      try {
        const data = await getCurrentCompanyInfo();
        if (data && data.company) {
          setCompany(data.company);
        }
      } catch (error) {
        console.error("Erreur lors de la récupération des données de l'entreprise:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchCompanyData();
  }, []);


  return (
    <>
      <div className={styles.shop}>
        <div className={styles.background}>
          <img src="/images/content/bg-shop.jpg" alt="Background" />
        </div>
        <Card className={styles.card}>
          <Profile company={company} />
          <div className={styles.control}>
            <div className={cn(styles.nav, styles.desktopNav)}>
              {navigation.map((x, index) => (
                <button
                  className={cn(styles.link, {
                    [styles.active]: index === activeIndex,
                  })}
                  onClick={() => setActiveIndex(index)}
                  key={index}
                >
                  {x}
                </button>
              ))}
            </div>
            <div className={styles.mobileNav}>
              <div style={{ position: 'relative' }}>
                <Dropdown
                  className={styles.dropdown}
                  value={navigation[activeIndex]}
                  setValue={(value) => {
                    const index = navigation.findIndex(x => x === value);
                    if (index !== -1) setActiveIndex(index);
                  }}
                  options={navigation}
                />
              </div>
            </div>
          </div>
        </Card>
        <div className={styles.wrap}>
          {activeIndex === 0 && (
            <NameAndDescription company={company}/>
          )}
          {activeIndex === 1 && (
            <ContractAndFiles company={company}/>
          )}
          {activeIndex === 2 && (
            <Tutor company={company}/>
          )}
        </div>
      </div>
    </>
  );
};

export default AccountCompany;
